import React, {useEffect, useState} from 'react';
import Banner from "components/banner/banner";
import UseContext from "hooks/useContext";
import useFetchData from "../../../hooks/useFetchData";
import StyledInput from "components/styledInput/StyledInput";
import SectionWrapper from "../components/SectionWrapper";

const Contact = () => {
    const {userData} = useFetchData();
    const {data, setData, language} = UseContext()
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.contact.${key}`, defaultValue)

    useEffect(() => {
        if (userData?.firstname && userData?.lastname) {
            if (data.contact_name !== undefined && data.contact_name !== null && data.contact_name === '') {
                setData(prevData => ({
                    ...prevData,
                    contact_name: userData?.firstname + ' ' + userData?.lastname
                }))
            }
            if (data.contact_poste !== undefined && data.contact_poste !== null && data.contact_poste === '') {
                setData(prevData => ({
                    ...prevData,
                    contact_poste: 'Responsable'
                }))
            }
        }
    }, [userData]);

    return (
        <SectionWrapper 
            title="Responsable de la mission" 
            description="Indiquez les informations du responsable en charge de l'intérimaire pour cette mission."
        >
            <StyledInput
                type="text"
                label={label('name', 'Nom complet du responsable')}
                value={data.contact_name}
                onChange={(e) => setData(prevData => ({
                    ...prevData,
                    contact_name: e.target.value
                }))}
            />
            <StyledInput
                type="text"
                label={label('poste', 'Fonction')}
                value={data.contact_poste}
                onChange={(e) => setData(prevData => ({
                    ...prevData,
                    contact_poste: e.target.value
                }))}
            />
        </SectionWrapper>
    );
};

export default Contact;
